import React from "react"

import { Avatar, ChannelAvatar, Service } from "components/common/styles"
import defaultAvatar from "assets/images/dashboard/avatar-empty-state.png"

import { CreationChannel } from "../types"

type ChannelAvatarBadgeProps = {
  channel?: CreationChannel | null
  testId?: string
  serviceTestId?: string
}

const ChannelAvatarBadge: React.FC<ChannelAvatarBadgeProps> = ({ channel, testId, serviceTestId }) => (
  <ChannelAvatar $enabled $clickable={false}>
    <Avatar
      src={channel?.avatar ?? defaultAvatar}
      width={28}
      height={28}
      $noShadow={true}
      $isRounded={true}
      onError={(event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = defaultAvatar
      }}
      data-testid={testId}
    />
    {channel?.service ? (
      <Service $size={14} title={channel.username} $type={channel.service} data-testid={serviceTestId} />
    ) : null}
  </ChannelAvatar>
)

export default ChannelAvatarBadge
